import { useRouter } from 'next/router'

import ROUTES from '~/shared/constants/routes.const'

import { getSubdomain } from '~/utils/domain'

import useCleanBasePathFromAsPath from '~/utils/useCleanBasePathFromAsPath'

// Builds the absolute public URL for the current page (canonical + og:url).
// Pass `routeOverride` when the served route is not the page's public URL — e.g.
// the A/B variant pages served at `/` via the middleware rewrite declare their
// public route so crawlers get a self-canonical instead of the `landing-*` variant path. Without it the URL is derived from the
// request path, as every normal page needs.
export function useUrl(routeOverride?: string): string {
  const router = useRouter()
  const asPath = useCleanBasePathFromAsPath()
  const subdomain = getSubdomain()

  const localePrefix = router.locale && router.locale !== router.defaultLocale ? `/${router.locale}` : ''
  const origin = `https://${subdomain}.houseofmath.com${localePrefix}`

  if (routeOverride !== undefined) {
    return `${origin}${routeOverride.replace(/\/$/, '')}`
  }

  const trimmedPath = asPath.replace(/\?.*$/g, '').replace(/\/$/, '')
  const pageNotFound = router.route === ROUTES.NOT_FOUND

  return `${origin}${pageNotFound ? '/page-not-found' : trimmedPath}`
}
